import { accentColor } from '../locatorDriftConstants';

export const healingTabStyles = {
  loader: {
    color: accentColor,
  },
};

export const healAllPanelStyles = {
  root: {
    p: 2,
  },
  header: {
    mb: 2,
  },
  title: {
    flexGrow: 1,
  },
  error: {
    mt: 2,
  },
  input: {
    width: '100%',
    padding: '8px 10px',
    border: '1px solid #d1d5db',
    borderRadius: 6,
    fontSize: 13,
    background: '#fff',
  },
};

export const healRunReportStyles = {
  root: {
    mt: 2,
    p: 2,
    bgcolor: '#fafafa',
  },
  header: {
    mb: 2,
  },
  clearButton: {
    ml: 'auto',
  },
  summaryGrid: {
    mb: 2,
  },
  monoCell: {
    fontFamily: 'monospace',
    fontSize: 12,
  },
  changeCell: {
    maxWidth: 420,
  },
  oldValue: {
    display: 'block',
    color: '#dc2626',
    fontFamily: 'monospace',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  newValue: {
    display: 'block',
    color: '#16a34a',
    fontFamily: 'monospace',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export const healingEventsTableStyles = {
  root: {
    p: 2,
  },
  header: {
    mb: 1,
  },
  sortLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  smallInput: {
    padding: '4px 6px',
    border: '1px solid #d1d5db',
    borderRadius: 4,
    fontSize: 12,
    background: '#fff',
  },
  locatorCell: {
    fontFamily: 'monospace',
    wordBreak: 'break-all',
    verticalAlign: 'top',
  },
  locatorCellScenario: {
    maxWidth: 230,
  },
};

export const topBreakersTableStyles = {
  root: {
    p: 2,
  },
  title: {
    mb: 1,
  },
  locatorCell: {
    fontFamily: 'monospace',
    wordBreak: 'break-all',
  },
};

export const healingStatColors = {
  total: '#6b7280',
  pending: '#d97706',
  accepted: '#16a34a',
  rejected: '#dc2626',
  autoHealed: '#2563eb',
  autoUnconfirmed: '#7c3aed',
};

export const healRunReportColors = {
  high: '#dc2626',
  medium: '#d97706',
  low: '#6b7280',
  auto: '#16a34a',
  prompt: '#d97706',
  failed: '#dc2626',
};
